<template lang="pug">

  section.thetext
    h2(:data-text="thetext", :class="{glitch : loading}" :style="{color: getActiveDecade.colorscheme.title}") {{thetext}}

</template>

<script>
  import { mapGetters } from 'vuex'
  export default  {
    name: 'TheText',
    props: {
      thetext: String,
      loading: Boolean
    },
    computed: {
      ...mapGetters([
        'getActiveDecade'
      ]),
    }
}
</script>

<style scoped lang="scss">
  h2{
    font-size: 8rem;
    line-height: 8rem;
    color: white;
    text-align: right;
    max-width: 50vw;
    @media screen and (max-width: 900px){
      font-size: 2rem;
      line-height: 2rem;
      letter-spacing: normal;
      position: absolute;
      top: 0.2rem;
      right: 1.5rem;
    }
  }
  .glitch{
    position: relative;
    opacity: 0.4;
    left: 20px;
  }

  .glitch:before{
    content:attr(data-text);
    position:absolute;
    left:-6px;
    text-shadow:4px 0 black;
    top:0;
    color:white;
    background:#e6e4e4;
    overflow:hidden;
    clip:rect(0,900px,0,0);
    animation:noise-anim-2 1s infinite linear alternate-reverse;
    font-size: 8rem;
    line-height: 8rem;
    text-align: right;
    max-width: 50vw;
    @media screen and (max-width: 900px){
      font-size: 2rem;
      line-height: 2rem;
      letter-spacing: normal;
      position: absolute;
      top: 0.2rem;
      right: 1.5rem;
    }
  }

  .glitch:after{
    content:attr(data-text);
    position:absolute;
    left:6px;
    text-shadow:-4px 0 black;
    top:0;
    color:white;
    background:#e6e4e4;
    overflow:hidden;
    clip:rect(0,900px,0,0);
    animation:noise-anim 0.5s infinite linear alternate-reverse;
    font-size: 8rem;
    line-height: 8rem;
    text-align: right;
    max-width: 50vw;
    @media screen and (max-width: 900px){
      font-size: 2rem;
      line-height: 2rem;
      letter-spacing: normal;
      position: absolute;
      top: 0.2rem;
      right: 1.5rem;
    }
  }
  @keyframes noise-anim{
    $steps:20;
    @for $i from 0 through $steps{
      #{percentage($i*(1/$steps))}{
        clip:rect(random(100)+px,9999px,random(100)+px,0);
        font-size: 90%;
      }
    }
  }
  @keyframes noise-anim-2{
    $steps:20;
    @for $i from 0 through $steps{
      #{percentage($i*(1/$steps))}{
        clip:rect(random(100)+px,9999px,random(100)+px,0);
        font-size: 110%;
      }
    }
  }
</style>
